<div class="h-full flex items-center">
  <ng-template *ngIf="state.isGroup; then groupBlock; else leafBlock"></ng-template>
</div>

<ng-template #groupBlock>
  {{ state.testCount === 0 ? '-' : '(' + state.testCount + ')' }}
</ng-template>

<ng-template #leafBlock>
  <button
    mat-button
    class="aligner open-dialog-button"
    y42StopPropagation
    (click)="openDialogClick()"
    *ngIf="state.leafNodeDisplayMode === 'tests-exist' || state.leafNodeDisplayMode === 'add-button'"
  >
    {{ state.leafNodeDisplayMode === 'tests-exist' ? state.testCountText : '+' }}
  </button>

  <ng-container *ngIf="state.leafNodeDisplayMode === 'no-tests'">
    <button
      mat-icon-button
      [matTooltip]="'Data Tests can only be set if there is at least one valid job'"
      class="small-icon-button instruction-trigger"
      y42StopPropagation
    >
      <fa-icon class="text-gray-600 fs-08" [icon]="['fal', 'info-circle']"></fa-icon>
    </button>
  </ng-container>
</ng-template>
